import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import OtpInput from "react-otp-input";

const PopupOtp = (props) => {
  const navigate = useNavigate();
  const closeModal = () => {
    props.setModalInput(false);
    document.body.classList.remove("modal-open");
  };
  const inputCodeAgain = () => {};
  const [config, setConfig] = useState({
    numInputs: 6,
    otpValue: "",
    separator: "",
    regex: /^([0-9]{0,})$/,
    isDisabled: false,
    isInputNum: true,
    hasErrored: false,
  });

  const TIME_OUT = 60;
  const [seconds, setSeconds] = useState(TIME_OUT - 1);
  const [numberResendOTPTime, setNumberResendOTPTime] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    countTime();
    props.setOtp("");
    return () => clearInterval(intervalRef.current);
  }, []);

  const countTime = () => {
    intervalRef.current = setInterval(() => {
      setSeconds((second) => {
        if (second < 1) {
          clearInterval(intervalRef.current);
          if (numberResendOTPTime < 2) {
            const el = document.querySelector("#resend_otp");
            el.classList.remove("disabled");
          }
          // handleButton("#submit_otp", true);
          return 0;
        }
        return second - 1;
      });
    }, 1000);
  };

  const handleButton = (id, isDisabled) => {
    const el = document.querySelector(id);
    if (!isDisabled) {
      el.classList.remove("disabled");
    } else {
      el.classList.add("disabled");
    }
  };

  const onChangeOTP = (value) => {
    if (!props?.isLoading) {
      props.setOtp(value);
    }
    // if (value.length === 6 && seconds !== 0) {
    //   handleButton("#submit_otp", false);
    // } else {
    //   handleButton("#submit_otp", true);
    // }
  };
  return (
    <>
      <div className="popup-overlay modal-notify modal-otp">
        <div className="popup-warp">
          <div className="icon-popup"></div>
          {/* <div className="close-modal" onClick={props.closeModalOTP}></div> */}
          <div className="popup-inner">
            <div className="content-popup">
              <form className="login-otp">
                <h3>XÁC NHẬN OTP</h3>
                <p className="note-login">
                  {/* Vui lòng nhập mã xác minh OTP đã được gửi qua SMS của SĐT */}
                  {/* <b> {props.dataSubmit.phone}</b> */}
                </p>
                <div className="form-group">
                  <OtpInput
                    value={props.otp}
                    onChange={onChangeOTP}
                    numInputs={Number(config.numInputs)}
                    // onChangeRegex={config.regex}
                    shouldAutoFocus
                    inputType="number"
                    separator={<span>{config.separator}</span>}
                    isInputNum={config.isInputNum}
                    hasErrored={config.hasErrored}
                    inputStyle={"otp-field__input"}
                    containerStyle={"otp-field"}
                    renderInput={(props) => <input {...props} />}
                  />
                </div>

                <p className="note-login" id="description-otp">
                  Mã OTP sẽ hết hiệu lực trong
                  <span className="text-red" id="count-down-time">
                    {" "}
                    {seconds} giây
                  </span>
                </p>
                {props.isErrorOTP && (
                  <div className="note-login">
                    <div className="ionic-label-center error">
                      <div className="text-red">
                        Mã xác thực chưa chính xác.
                        <br /> Vui lòng kiểm tra lại thông tin.
                      </div>
                    </div>
                  </div>
                )}

                <div className="group-btn-inline">
                  <button
                    id="submit_otp"
                    type="button"
                    className="btn btn-info   btn-block"
                    onClick={props.closeModalOTP}
                  >
                    <a>Đóng</a>
                  </button>
                  <button
                    id="resend_otp"
                    type="button"
                    className="btn btn-primary  btn-block disabled"
                    onClick={() => {
                      if (numberResendOTPTime < 3) {
                        const el = document.querySelector("#resend_otp");
                        el.classList.add("disabled");
                        setSeconds(TIME_OUT);
                        props.resendOTP();
                        countTime();
                        setNumberResendOTPTime(numberResendOTPTime + 1);
                      }
                    }}
                  >
                    <a> GỬI LẠI OTP</a>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default PopupOtp;
